/**
 * FormPersist — lightweight localStorage helper for retaining form field values
 * across page loads (e.g. after a successful AJAX form submission + reload).
 *
 * Usage:
 *   FormPersist.save('my_key', { name: 'Alice', email: 'a@b.com' });
 *   FormPersist.restore('my_key', { name: 'field-id-name', email: 'field-id-email' });
 *   FormPersist.clear('my_key');
 */

var FormPersist = (function () {
  /**
   * Persist an object of field values to localStorage.
   * @param {string} storageKey
   * @param {Object.<string, string>} data  Plain key→value pairs to store.
   */
  function save(storageKey, data) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(data));
    } catch (_) {}
  }

  /**
   * Read persisted data back from localStorage.
   * Returns null when nothing has been saved or storage is unavailable.
   * @param {string} storageKey
   * @returns {Object|null}
   */
  function load(storageKey) {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || 'null');
    } catch (_) {
      return null;
    }
  }

  /**
   * Restore saved values into form fields.
   * Only fills a field when it is currently empty — never overwrites typed input.
   * @param {string} storageKey
   * @param {Object.<string, string>} fieldMap  Maps storage key → element id.
   *   e.g. { name: 'quote-name', email: 'quote-email' }
   */
  function restore(storageKey, fieldMap) {
    var data = load(storageKey);
    if (!data) return;
    Object.keys(fieldMap).forEach(function (key) {
      var el = document.getElementById(fieldMap[key]);
      if (el && !el.value) el.value = data[key] || '';
    });
  }

  /**
   * Remove a persisted entry from localStorage.
   * @param {string} storageKey
   */
  function clear(storageKey) {
    try {
      localStorage.removeItem(storageKey);
    } catch (_) {}
  }

  return { save: save, load: load, restore: restore, clear: clear };
})();
